// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"417":"8ec0095b","862":"31d6cfe0"}[chunkId] + ".chunk.css";
};